module.exports = __webpack_public_path__ + "img/brand-cases19.6656fb78.png";